module.exports = __webpack_public_path__ + "files/26658a486c134a7692ec980b4b587364.png";